module.exports = __webpack_public_path__ + "static/flat-6e82e66903e20510dad37c1ef15d39aa.jpg";